//      
export { default } from './use-droppable-publisher';



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-droppable-publisher/index.js